import { BACKEND_URL } from '../config'

export const getAppUrl = appId => `${BACKEND_URL}/apps/${appId}/clients/runner`

export const getAppIconUrl = appId => `${BACKEND_URL}/apps/${appId}/icon`

export const getAppIdUrl = query => `${BACKEND_URL}/app-search?${query}`
